import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable, Post } from '@shapeable/types';
import { breakpoints, theme, ColorTokens } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { PostBannerLayout, SiteHeaderProvider } from '@shapeable/ui';

const cls = classNames('post-layout');

// -------- Types -------->

// -------- Props -------->

export type PostLayoutProps = Classable & HasChildren & { 
  entity?: Post;
};

export const PostLayoutDefaultProps: Omit<PostLayoutProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});


// -------- Components -------->

const My = {
  Container: styled(PostBannerLayout)<ContainerProps>`${ContainerStyles}`,
};

export const PostLayout: Shapeable.FC<PostLayoutProps> = (props) => {
  const { className, children, entity } = props;
  
  return (
    <SiteHeaderProvider value={{
      variant: 'default',
    }}>
    <My.Container 
      className={cls.name(className)}
      entity={entity}
     
    />
    </SiteHeaderProvider>
  )
};

PostLayout.defaultProps = PostLayoutDefaultProps;
PostLayout.cls = cls;